export enum CashOrderStatusEnum {
  PENDING_APPROVAL = "PENDING_APPROVAL",
  REJECTED_APPROVAL = "REJECTED_APPROVAL",
  APPROVED_APPROVAL = "APPROVED_APPROVAL",
}

export interface ICashOrderDTO {
  id: number;
  status: CashOrderStatusEnum;
  user: ICashOrderUserDTO;
  message: string;
  createdAt: string | Date;
  updatedAt?: string | Date;
  productCode: string;
  serviceCode?: string;
  commentsUpdated?: string;
}

export interface ICashOrderUserDTO {
  id: number;
  username: string;
  email: string;
}
